
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonialskeyword from './TestimonialKeyword';

function Punetomumbaicabs() {



    const cardData =
    {
        keyword: 'Pune to Mumbai Cabs',
        heading: 'Skyline Cabs: Pune to Mumbai Cabs',
        headingDescription: 'Skyline Cabs offers reliable, comfortable, and affordable Pune to Mumbai Cabs. Whether you are heading to Mumbai for a business meeting, a weekend getaway, or need an airport transfer, our well-maintained fleet and experienced drivers ensure a smooth and stress-free ride. Enjoy premium amenities, punctual service, and 24/7 customer support with Skyline Cabs — your trusted travel partner for Pune to Mumbai journeys.',

        top: 'Top Places to Visit in Mumbai with Skyline Cabs',

       "topPlaces": [
    {
        "title": "Gateway of India",
        "description": "An iconic landmark, the Gateway of India is a must-visit destination in Mumbai. Overlooking the Arabian Sea, this grand arch was built in 1924 to commemorate the visit of King George V and Queen Mary to India. It serves as a historic reminder of the colonial era and is a popular spot for photography, ferry rides to Elephanta Caves, and enjoying the sea breeze. The surrounding area is bustling with street vendors, tourists, and local performers, adding to the vibrant charm of the place."
    },
    {
        "title": "Marine Drive",
        "description": "Known as the Queen’s Necklace, Marine Drive is a 3.6 km long boulevard along the coast of South Mumbai. The stretch is lined with palm trees and offers stunning views of the Arabian Sea, making it an ideal spot for evening strolls, jogging, or simply relaxing by the sea. At night, the streetlights along the curved road resemble a string of pearls, creating a breathtaking visual effect. Marine Drive is also home to some of Mumbai’s finest restaurants, cafes, and luxury hotels, making it a favorite hangout for locals and tourists alike."
    },
    {
        "title": "Elephanta Caves",
        "description": "A UNESCO World Heritage Site, the Elephanta Caves are a group of rock-cut temples located on Elephanta Island, approximately 11 km from Mumbai. These caves date back to the 5th-7th century AD and are primarily dedicated to Lord Shiva. The most famous attraction here is the massive three-headed sculpture of Trimurti, symbolizing the three aspects of Shiva: Creator, Preserver, and Destroyer. The journey to the caves involves a scenic ferry ride from the Gateway of India, making it an adventure-filled and culturally enriching experience."
    },
    {
        "title": "Chhatrapati Shivaji Maharaj Terminus (CSMT)",
        "description": "A magnificent railway station and UNESCO-listed site, CSMT is one of the finest examples of Victorian Gothic Revival architecture in India. Built in 1887 during British rule, this historic structure features a blend of Indian and European design elements, including domes, turrets, stained-glass windows, and intricate carvings. It serves as the headquarters of the Central Railway and is one of the busiest railway stations in India. The illuminated station at night is a sight to behold, attracting architecture and history enthusiasts."
    },
    {
        "title": "Siddhivinayak Temple",
        "description": "One of Mumbai's most revered temples, Siddhivinayak Temple is dedicated to Lord Ganesha and attracts thousands of devotees daily. Built in 1801, the temple is known for its beautiful idol of Ganesha, carved from a single black stone with an elephant trunk tilted to the right. Celebrities, politicians, and common devotees visit the temple to seek blessings. Tuesdays witness a massive crowd of worshippers, as the day is considered auspicious for Lord Ganesha. The temple's serene ambiance offers a spiritual retreat amid Mumbai’s fast-paced life."
    },
    {
        "title": "Juhu Beach",
        "description": "Famous for its vibrant atmosphere, Juhu Beach is one of Mumbai’s most popular attractions. Stretching along the Arabian Sea, it is a hub for locals and tourists seeking relaxation, fun activities, and delicious street food. Visitors can enjoy horse rides, camel rides, and local delicacies like pav bhaji, vada pav, and bhel puri from the numerous food stalls lining the beach. Juhu Beach is also a popular spot for Bollywood celebrity sightings, as many film stars reside in the nearby luxurious localities."
    },
    {
        "title": "Colaba Causeway",
        "description": "A shopper’s paradise, Colaba Causeway is known for its lively street markets, trendy cafes, and colonial-era architecture. It offers a diverse range of goods, including jewelry, handicrafts, clothing, antiques, and souvenirs at bargain prices. The area is also home to some of Mumbai’s iconic eateries, such as Leopold Café and Café Mondegar, which are must-visit spots for food lovers. The fusion of street shopping, historical charm, and vibrant cafes makes Colaba Causeway an unmissable attraction in Mumbai."
    },
    {
        "title": "Haji Ali Dargah",
        "description": "A stunning mosque and dargah situated on an islet in the Arabian Sea, Haji Ali Dargah is one of Mumbai’s most significant religious landmarks. Built in the 15th century, it houses the tomb of the Muslim saint Pir Haji Ali Shah Bukhari. The dargah is accessible via a narrow walkway during low tide, offering a unique experience as you walk toward this architectural marvel. It attracts visitors from all faiths, offering a peaceful retreat with mesmerizing views of the sea and skyline."
    },
    {
        "title": "Bandra-Worli Sea Link",
        "description": "An engineering marvel, the Bandra-Worli Sea Link is an eight-lane cable-stayed bridge that connects Bandra to Worli, significantly reducing travel time between the suburbs and South Mumbai. Spanning 5.6 km, it offers breathtaking views of the Mumbai skyline, especially at sunset and night when the bridge is beautifully illuminated. It is a symbol of Mumbai’s modern infrastructure and development, making it a favorite spot for photographers and travelers."
    },
    {
        "title": "Film City",
        "description": "Get a glimpse into Bollywood at Mumbai's famous Film City, officially known as Dadasaheb Phalke Chitranagari. Spread across 520 acres, it features multiple sets, including replicas of villages, urban streets, temples, and even forests, making it a key location for Bollywood films, TV shows, and commercials. Visitors can take guided tours to witness live shoots, explore film sets, and learn about the behind-the-scenes magic of India’s entertainment industry. For movie buffs, this is a dream destination."
    }
],


"services": [
    {
      "name": "Pune Mumbai Cab",
      "description": "Traveling between Pune and Mumbai? Book your ride with Skyline Cabs for a comfortable and reliable journey. We provide well-maintained vehicles to ensure a smooth and hassle-free ride."
    },
    {
      "name": "Mumbai to Pune Taxi",
      "description": "Experience a seamless ride from Mumbai to Pune with Skyline Cabs. Choose from Ertiga, Innova, and more. Enjoy professional drivers and air-conditioned comfort for a stress-free journey."
    },
    {
      "name": "Pune to Mumbai Cheapest Cab",
      "description": "Looking for affordable travel between Pune and Mumbai? Skyline Cabs offers competitive rates without compromising on comfort or safety. Contact us for the best pricing."
    },
    {
      "name": "Pune to Mumbai Cab Service",
      "description": "Skyline Cabs provides reliable taxi services from Pune to Mumbai. Our experienced drivers ensure a smooth and punctual journey. Book with us for stress-free travel."
    },
    {
      "name": "Pune to Mumbai Cab Fare",
      "description": "We offer transparent and competitive pricing for your Pune to Mumbai journey. No hidden charges—just fair rates based on your trip details."
    },
    {
      "name": "Pune Mumbai Taxi Service",
      "description": "Skyline Cabs offers dependable taxi service from Pune to Mumbai for business, leisure, or sightseeing. Travel in modern, comfortable vehicles tailored to your needs."
    },
    {
      "name": "Pune to Mumbai Cab Booking",
      "description": "Booking your Pune to Mumbai cab is quick and easy with Skyline Cabs. Enjoy flexible options and a hassle-free reservation process."
    },
    {
      "name": "Pune Mumbai Cab Rental",
      "description": "Rent a cab from Pune to Mumbai with Skyline Cabs for flexibility and comfort. Choose from a wide range of vehicles, ideal for one-way or round trips."
    },
    {
      "name": "Pune Mumbai Pune Car Rental",
      "description": "Skyline Cabs offers round-trip car rentals from Pune to Mumbai and back. Enjoy convenience, safety, and a well-planned itinerary with experienced drivers."
    },
    {
      "name": "Pune Mumbai Taxi Price",
      "description": "We keep our taxi pricing between Pune and Mumbai transparent and affordable. Contact us for an accurate quote tailored to your journey."
    },
    {
      "name": "Pune Mumbai Car Rental",
      "description": "Choose from a range of vehicles including Ertiga and Innova for your Pune to Mumbai car rental. Ideal for family, group, or business travel."
    },
    {
      "name": "Pune to Mumbai Ertiga Cab",
      "description": "Book an Ertiga cab with Skyline Cabs for your Pune to Mumbai trip. It's a cost-effective, spacious, and comfortable choice for small groups or families."
    },
    {
      "name": "Pune to Mumbai Innova Cab",
      "description": "Travel in premium comfort with an Innova cab from Pune to Mumbai. Ideal for families or corporate groups needing more space and convenience."
    },
    {
      "name": "Pune to Mumbai Cab Booking",
      "description": "Secure your ride quickly with Skyline Cabs. We offer flexible booking for Pune to Mumbai trips, perfect for business or leisure travel."
    },
    {
      "name": "Pune to Mumbai Innova Crysta",
      "description": "Book an Innova Crysta for a luxurious Pune to Mumbai ride. Extra comfort and style make it ideal for executives and families alike."
    },
    {
      "name": "Pune Mumbai Innova Rental",
      "description": "Rent an Innova for a smooth Pune to Mumbai journey. Enjoy ample space, experienced drivers, and a relaxed travel experience."
    },
    {
      "name": "Pune to Mumbai International Airport Cab",
      "description": "Heading to Mumbai International Airport? Book a cab from Pune with Skyline Cabs for a timely and comfortable airport transfer."
    },
    {
      "name": "Pune to Mumbai Cab Fare",
      "description": "Skyline Cabs offers competitive and transparent fares for all Pune to Mumbai routes. Contact us to get a personalized quote."
    },
    {
      "name": "Pune to Mumbai Skyline Cab",
      "description": "Enjoy stylish and comfortable travel from Pune to Mumbai with our Skyline cab option. Ideal for premium travel experiences."
    }
  ],

  "tableData": [
    ["Pune Mumbai Cab", "-Mumbai to Pune Taxi"],
    ["Pune to Mumbai Cheapest Cab", "-Pune to Mumbai Cab Service"],
    ["Pune to Mumbai Cab Fare", "-Pune Mumbai Taxi Service"],
    ["Pune to Mumbai Cab Booking", "-Pune Mumbai Cab Rental"],
    ["Pune Mumbai Pune Car Rental", "-Pune Mumbai Taxi Price"],
    ["Pune Mumbai Car Rental", "-Pune to Mumbai Ertiga Cab"],
    ["Pune to Mumbai Innova Cab", "-Pune to Mumbai Cab Booking"],
    ["Pune to Mumbai Innova Crysta", "-Pune Mumbai Innova Rental"],
    ["Pune to Mumbai International Airport Cab", "-Pune to Mumbai Cab Fare"],
    ["Pune to Mumbai Skyline Cab", "-Luxury Pune Mumbai Travel"]
  ],

  whychoose: [
    {
        "WhyChooseheading": "Timely and Reliable Pune to Mumbai Cabs",
        "WhyChoosedescription": "Skyline Cabs ensures on-time pickups and drop-offs for your Pune to Mumbai journey. Our commitment to punctuality means you never have to worry about delays, whether it's for business meetings or flights."
    },
    {
        "WhyChooseheading": "Comfortable Rides with Spacious Vehicles",
        "WhyChoosedescription": "Travel in comfort with Skyline Cabs. Our fleet includes well-maintained sedans, SUVs, and premium cars, giving you a smooth and spacious ride no matter your travel needs."
    },
    {
        "WhyChooseheading": "Professional and Courteous Drivers",
        "WhyChoosedescription": "Our experienced drivers know the Pune to Mumbai route inside-out. They are courteous, background-verified, and focused on delivering a safe and pleasant travel experience."
    },
    {
        "WhyChooseheading": "Transparent and Affordable Pricing",
        "WhyChoosedescription": "With Skyline Cabs, you get fair, competitive pricing for Pune to Mumbai cabs—no hidden fees, just honest rates and a clear fare breakdown."
    },
    {
        "WhyChooseheading": "24/7 Pune to Mumbai Cab Services",
        "WhyChoosedescription": "Need a cab early in the morning or late at night? Skyline Cabs is available 24/7 to ensure you can travel whenever you need, with flexible booking options."
    },
    {
        "WhyChooseheading": "Clean and Well-Maintained Fleet",
        "WhyChoosedescription": "Our vehicles are regularly serviced and thoroughly cleaned to provide a safe and hygienic environment for your Pune to Mumbai journey."
    },
    {
        "WhyChooseheading": "Quick and Easy Booking Process",
        "WhyChoosedescription": "Booking your Pune to Mumbai cab is simple with Skyline Cabs. Use our user-friendly website, mobile app, or call our support team for hassle-free reservations."
    },
    {
        "WhyChooseheading": "Safe and Secure Travel Experience",
        "WhyChoosedescription": "All Skyline Cabs come equipped with GPS tracking and safety features. Combined with our expert drivers, you can relax and enjoy a secure ride from Pune to Mumbai."
    }
]



    }


    const faqData = [
        {
            id: 1,
            question: 'How can I book a Pune to Mumbai cab with Skyline Cabs?',
            answer:
                'Booking with Skyline Cabs is simple and fast. Use our website or mobile app to book your cab, or call our 24/7 customer support for a hassle-free reservation.',
        },
        {
            id: 2,
            question: 'Are Skyline Cabs drivers trained for long-distance travel?',
            answer:
                'Yes, our drivers are experienced in handling long-distance routes like Pune to Mumbai. They are courteous, professional, and prioritize your safety and comfort.',
        },
        {
            id: 3,
            question: 'What vehicle options do you provide for the Pune to Mumbai route?',
            answer:
                'We offer a range of options from budget hatchbacks to comfortable sedans and spacious SUVs. All vehicles are maintained regularly to ensure a safe ride.',
        },
        {
            id: 4,
            question: 'How do I make a payment for my ride?',
            answer:
                'Skyline Cabs accepts payments via UPI, credit/debit cards, net banking, and cash. We also provide digital receipts for all transactions.',
        },
        {
            id: 5,
            question: 'Can I book a round trip from Pune to Mumbai with Skyline Cabs?',
            answer:
                'Yes, round-trip bookings are available. Just mention your return date and preferred pickup time when booking.',
        },
        {
            id: 6,
            question: 'Are there extra charges for waiting or detours?',
            answer:
                'All additional charges are clearly communicated before the ride. We believe in honest pricing with no surprises.',
        },
        {
            id: 7,
            question: 'Is sightseeing in Mumbai available as part of the trip?',
            answer:
                'Yes, you can opt for a sightseeing tour in Mumbai. Just inform us at the time of booking, and we’ll create a customized itinerary for you.',
        },
        {
            id: 8,
            question: 'What is the luggage capacity for Pune to Mumbai cabs?',
            answer:
                'Our cabs can easily accommodate regular luggage. For larger baggage, let us know in advance so we can arrange a vehicle accordingly.',
        },
        {
            id: 9,
            question: 'Do you offer corporate travel services?',
            answer:
                'Yes, Skyline Cabs offers reliable travel solutions for corporate clients, including flexible billing and dedicated support.',
        },
        {
            id: 10,
            question: 'Why choose Skyline Cabs for Pune to Mumbai travel?',
            answer:
                'Skyline Cabs stands out for its on-time service, clean and comfortable vehicles, courteous drivers, and competitive pricing. Your comfort is our priority.',
        },
    ];
    
    const someReviews = [
        {
            name: "Mr. Rajesh Mehra",
            rating: 5,
            review: "My experience with Skyline Cabs was top-notch. The cab arrived early, the driver was extremely courteous, and the car was clean and air-conditioned. It felt like a premium experience from Pune to Mumbai."
        },
        {
            name: "Miss. Kavita Sharma",
            rating: 4,
            review: "The journey was smooth and comfortable. The driver was well-spoken and knew the route well. We even made a quick stop for tea, and he was happy to accommodate. Would definitely recommend Skyline Cabs!"
        },
    ];
    



    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7620911746",


        ],
        email: "booking@skylinecabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        {
            place: "/images/keyword/21.jpg",
            text: " Pune to Mumbai Sedan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


    const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Mumbai Cab Service",
  "image": "https://skylinecabs.com/assets/images/pune-to-mumbai-cab-service.jpg",
  "description": "Book Pune to Mumbai cab service with Skyline Cabs for reliable one-way and round-trip taxi rides at affordable fares. Choose from AC sedans, SUVs, and 24/7 service.",
  "brand": {
    "@type": "Brand",
    "name": "Skyline Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8427"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1300",
    "availability": "https://schema.org/InStock",
    "url": "https://skylinecabs.com/pune-to-mumbai-cab-service"
  }
};



     
      


    return (
        <div>
<Helmet>
  <title>Pune to Mumbai Cab Service | Skyline Cabs</title>
  <meta 
    name="description" 
    content="Book Pune to Mumbai cab service with Skyline Cabs for reliable one-way and round-trip taxi rides at affordable fares. Choose from AC sedans, SUVs, and 24/7 service." 
  />
  <meta 
    name="keywords" 
    content="Pune to Mumbai Cab Service, Pune Mumbai Taxi Booking, One-Way Cab Pune to Mumbai, Round Trip Cab Pune to Mumbai, AC Cab Pune to Mumbai, Sedan Cab Pune Mumbai, SUV Taxi Pune to Mumbai, Pune to Mumbai Airport Taxi, Affordable Pune to Mumbai Cab, Safe Cab Ride Pune to Mumbai, 24x7 Pune Mumbai Cab, Skyline Cabs Pune Mumbai, Executive Cab Pune to Mumbai, Verified Taxi Pune to Mumbai" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section
                className="bg-cover position-relative"
                style={{
                    background: 'url(/img/bg-title.jpg) no-repeat',
                }}
                data-overlay="5"
            >
                <div className="container">
                    <div className="row align-items-center justify-content-center">
                        <div className="col-xl-7 col-lg-9 col-md-12">
                            <div className="fpc-capstion text-center my-4">
                                <div className="fpc-captions">
                                    <h1 className="xl-heading text-light">{cardData.keyword}</h1>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/1.jpg' alt='img' className='img-fluid'/>
                            <h3 className="py-1"
                                style={{
                                    color: '#F26722', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Skyline Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <Testimonialskeyword reviews={someReviews} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div> */}

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F26722',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F26722' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <div className=''>
                                                <a href="tel:+91 7620911746" className="d-block  text-white">+91 7620911746</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@skylinecabs.com" className=" text-white d-block">
                                                    booking@skylinecabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Skyline Cab<br />
                                                        Satya Nagar, 90 feet rd Saki Naka, Mumbai, Andheri Maharashtra 400072

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punetomumbaicabs;